import { FC, useEffect, useRef } from 'react';

import anime from 'animejs';

import styles from './Background.module.css';

const Background: FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Create floating elements
    const elements = Array.from({ length: 15 }, (_, i) => {
      const el = document.createElement('div');
      el.className = styles.floatingElement;
      // Alternate between circles and rounded rectangles
      el.classList.add(i % 2 === 0 ? styles.circle : styles.rectangle);
      containerRef.current?.appendChild(el);
      return el;
    });

    // Animate elements
    elements.forEach((el, i) => {
      const delay = i * 200;
      const duration = 4000 + Math.random() * 2000;

      anime({
        targets: el,
        translateX: () => {
          const width = window.innerWidth;
          const randomX = anime.random(-width * 0.2, width * 0.2);
          return [0, randomX];
        },
        translateY: () => {
          const height = window.innerHeight;
          const randomY = anime.random(-height * 0.15, height * 0.15);
          return [0, randomY];
        },
        scale: [
          { value: [0.5, 1], duration: duration * 0.4, easing: 'easeOutSine' },
          { value: 0.5, duration: duration * 0.6, easing: 'easeInSine' },
        ],
        opacity: [
          { value: [0, 0.12], duration: duration * 0.4, easing: 'easeOutSine' },
          { value: 0, duration: duration * 0.6, easing: 'easeInSine' },
        ],
        delay: delay,
        duration: duration,
        loop: true,
        easing: 'easeInOutSine',
      });
    });

    return () => {
      elements.forEach(el => el.remove());
    };
  }, []);

  return (
    <div className={styles.background} ref={containerRef} aria-hidden="true">
      <div className={styles.gradientOverlay} />
    </div>
  );
};

export default Background;
